import { Minus, X, Maximize2, Search } from 'lucide-react';

const MENUS = ['File','Edit','View','Git','Project','Build','Debug','Analyze','Tools','Extensions','Window','Help'];

export default function TitleBar({ projectName = 'HelloWorld', step = 0 }) {
  const suffix = step === 4 ? ' (Running)' : '';

  return (
    <div className="relative flex items-center h-[30px] bg-[#1b1b1b] border-b border-[#333] flex-shrink-0">
      {/* Build progress bar — indeterminate, only during build */}
      {step === 3 && <div className="build-progress-bar" />}

      {/* VS Logo */}
      <div className="w-10 h-full flex items-center justify-center flex-shrink-0">
        <svg viewBox="0 0 40 40" className="w-5 h-5">
          <rect width="40" height="40" rx="4" fill="#68217A"/>
          <path d="M7 10 L18 28 L20 31 L22 28 L33 10 L27 10 L20 23 L13 10Z" fill="white"/>
        </svg>
      </div>

      {/* Menu items */}
      {MENUS.map(m => (
        <div key={m} className="px-2 h-full flex items-center text-[12px] hover:bg-white/10 cursor-pointer">
          {m}
        </div>
      ))}

      {/* Center title — shows (Running) when debugging */}
      <div className="flex-1 text-center text-[12px] text-[#ccc] pointer-events-none truncate px-4">
        {projectName}{suffix} - Microsoft Visual Studio
      </div>

      {/* Search box */}
      <div className="flex items-center bg-[#2d2d30] border border-[#555] rounded-sm px-2 h-[20px] gap-1.5 mr-2 w-44">
        <Search size={11} className="text-[#858585] flex-shrink-0"/>
        <span className="text-[11px] text-[#555]">Search (Ctrl+Q)</span>
      </div>

      {/* Window controls */}
      <div className="flex h-full flex-shrink-0">
        <div className="w-[46px] h-full flex items-center justify-center text-[11px] hover:bg-white/10 cursor-pointer"><Minus size={14}/></div>
        <div className="w-[46px] h-full flex items-center justify-center text-[11px] hover:bg-white/10 cursor-pointer"><Maximize2 size={12}/></div>
        <div className="w-[46px] h-full flex items-center justify-center text-[11px] hover:bg-[#e81123] cursor-pointer"><X size={14}/></div>
      </div>
    </div>
  );
}
